import { Pipe, PipeTransform } from '@angular/core';

export interface TagContainerStylePipeData {
  isMultiLine: boolean;
  isCollapsed: boolean;
  lineHeight: number;
}

@Pipe({
  name: 'tagContainerStyle'
})
export class TagContainerStylePipe implements PipeTransform {
  transform(data: TagContainerStylePipeData): any {
    if (data.isMultiLine && data.isCollapsed) {
      return {
        'max-height': `${data.lineHeight}px`,
        overflow: 'hidden'
      };
    } else {
      return undefined;
    }
  }
}
